import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Luxury%20fashion%20flat%20lay%20composition%20with%20sneakers%20t-shirts%20accessories%20and%20shopping%20bags%20arranged%20on%20clean%20warm%20beige%20background%2C%20soft%20natural%20lighting%20from%20above%2C%20editorial%20fashion%20product%20photography%2C%20minimal%20modern%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition%2C%20no%20text&width=1800&height=900&seq=hero-prod-bg-001&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 text-xs font-medium tracking-wide uppercase bg-accent-500/30 text-accent-200 rounded-full mb-6 backdrop-blur-sm">
            Updated 2026 Guides
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            The Ultimate Basetao Spreadsheet Resource Hub
          </h1>
          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto leading-relaxed mb-8">
            Find Better Products, Track Orders, Compare Shipping Costs, and Shop Smarter With Professional Basetao Spreadsheet Guides.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/basetao-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-book-open-line mr-2"></i>
              Explore Basetao Spreadsheet Guides
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-external-link-line mr-2"></i>
              Visit Main Website
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-xs text-background-300">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i> Updated 2026 Guides
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i> 100+ Spreadsheet Resources
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i> Shipping Cost Research
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i> Beginner Friendly Tutorials
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}